import { FunctionComponent } from 'react'

const Cloud: FunctionComponent = ({}) => {
    return (
        <svg
            width="161"
            height="159"
            viewBox="0 0 161 159"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="artwork">
                <path
                    id="Vector"
                    d="M149.797 78.3398H87.6267V80.9398H149.797V78.3398Z"
                    fill="#001E50"
                />
                <path
                    id="Vector_2"
                    d="M160.587 85.88H148.497V73.79H160.587V85.88ZM151.097 83.28H157.987V76.39H151.097V83.28Z"
                    fill="#001E50"
                />
                <path
                    id="Vector_3"
                    d="M138.877 119.81L118.247 102.66H87.2567V100.06H119.177L140.537 117.82L138.877 119.81Z"
                    fill="#001E50"
                />
                <path
                    id="Vector_4"
                    d="M150.497 129.61H138.407V117.52H150.497V129.61ZM141.007 127.01H147.897V120.12H141.007V127.01Z"
                    fill="#001E50"
                />
                <path
                    id="Vector_5"
                    d="M118.697 141.119L98.0667 123.959H86.1367V121.359H98.9967L120.357 139.119L118.697 141.119Z"
                    fill="#001E50"
                />
                <path
                    id="Vector_6"
                    d="M130.317 150.909H118.227V138.819H130.317V150.909ZM120.827 148.309H127.717V141.419H120.827V148.309Z"
                    fill="#001E50"
                />
                <path
                    id="Vector_7"
                    d="M119.177 59.6094H87.2567V57.0094H118.247L138.877 39.8594L140.537 41.8494L119.177 59.6094Z"
                    fill="#001E50"
                />
                <path
                    id="Vector_8"
                    d="M150.497 42.1593H138.407V30.0693H150.497V42.1593ZM141.007 39.5593H147.897V32.6693H141.007V39.5593Z"
                    fill="#001E50"
                />
                <path
                    id="Vector_9"
                    d="M98.9967 38.3096H86.1367V35.7096H98.0667L118.697 18.5596L120.357 20.5496L98.9967 38.3096Z"
                    fill="#001E50"
                />
                <path
                    id="Vector_10"
                    d="M130.317 20.8498H118.227V8.75977H130.317V20.8498ZM120.827 18.2598H127.717V11.3698H120.827V18.2598Z"
                    fill="#001E50"
                />
                <path
                    id="Vector_11"
                    d="M3.16673 94.8198C2.59673 91.2698 3.12673 81.9498 3.14673 81.5498L7.03673 81.7698C6.88673 84.3498 6.59673 91.5998 7.01673 94.1898L3.16673 94.8098V94.8198Z"
                    fill="url(#paint0_linear_223_5711)"
                />
                <path
                    id="Vector_12"
                    d="M6.71673 78.5592L2.83673 78.1792C3.25673 73.7792 6.29673 65.7892 14.6567 64.2992C15.4767 64.1492 16.7067 67.9792 16.4167 67.9992C7.81673 68.7192 6.75673 78.1392 6.71673 78.5592Z"
                    fill="url(#paint1_linear_223_5711)"
                />
                <path
                    id="Vector_13"
                    d="M8.85669 83.9793V75.8193H0.696693V83.9793H8.85669Z"
                    fill="#001E50"
                />
                <path
                    id="Vector_14"
                    d="M89.1867 47.8097V23.9397C89.5767 17.3097 86.7367 4.05967 73.2267 1.34967C66.2867 -0.0403252 59.6767 1.91967 54.0967 6.99967C51.2467 9.59967 49.3767 12.3697 48.4567 13.8897L47.7267 14.2797C42.5367 15.3697 26.5667 20.2497 27.6267 38.8597C23.5567 41.3397 10.1167 50.6597 13.3767 63.7097L13.5167 64.0997C13.7267 64.5197 18.4067 73.8197 27.9967 76.5597C27.4867 79.4197 27.1167 84.7397 29.9867 89.2797C32.4767 93.2097 36.7767 95.6197 42.7567 96.4497L44.6867 96.7197L45.2167 92.8597L43.2867 92.5897C38.5067 91.9297 35.1367 90.1197 33.2867 87.2197C30.1767 82.3397 32.1567 75.7497 32.1767 75.6797L32.8467 73.5597L30.6567 73.1797C22.3867 71.7297 17.7767 63.8197 17.0967 62.5497C14.3267 50.5997 30.4167 41.7397 30.5767 41.6497L31.7167 41.0297L31.5967 39.7497C29.8267 21.1697 47.3767 18.1997 49.5467 17.9097C51.2967 18.0897 55.7067 19.0297 57.5867 21.5497L58.7467 23.1097L61.8767 20.7897L60.7167 19.2297C58.6767 16.4897 55.1967 15.1697 52.6867 14.5397C53.6167 13.1997 54.9967 11.4497 56.8067 9.80967C61.4767 5.58967 66.7467 4.02967 72.4567 5.17967C86.0067 7.88967 85.3267 23.0797 85.2867 23.8297V47.8097C85.2767 51.1797 84.9467 130.54 85.3067 139.06C85.6267 146.62 77.7367 152.97 65.6867 154.88C56.9367 156.27 49.4467 147.5 46.2967 143.13C48.6667 142.38 52.0567 140.62 55.7867 136.54L57.0967 135.1L54.2167 132.47L52.9067 133.91C47.6167 139.71 43.4167 139.79 43.1367 139.78H43.1267H43.0767C36.1667 139.49 30.7667 137.26 27.0167 133.15C20.5367 126.05 20.9967 115.55 20.9967 115.45L21.0867 113.78L19.4567 113.43C9.62673 111.34 7.29673 96.0197 7.27673 95.8697L6.99673 93.9397L3.14673 94.4897L3.42673 96.4197C3.52673 97.1297 5.94673 113.13 17.1067 116.82C17.2067 120.38 18.0967 129.12 24.1167 135.74C28.2267 140.26 33.8967 142.85 40.9767 143.51V143.53L41.6067 143.57C41.7167 143.57 41.8167 143.6 41.9267 143.6C44.1467 147.06 52.5567 158.91 63.8067 158.91C64.6267 158.91 65.4667 158.85 66.3167 158.71C80.4167 156.48 89.6267 148.52 89.2167 138.88C88.8667 130.45 89.1967 48.6297 89.2067 47.7997L89.1867 47.8097Z"
                    fill="url(#paint2_linear_223_5711)"
                />
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_223_5711"
                    x1="4.96673"
                    y1="81.5498"
                    x2="4.96673"
                    y2="94.8198"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#00C5FC" stopOpacity="0" />
                    <stop
                        offset="0.08"
                        stopColor="#00C5FC"
                        stopOpacity="0.03"
                    />
                    <stop offset="0.2" stopColor="#00C5FC" stopOpacity="0.1" />
                    <stop
                        offset="0.34"
                        stopColor="#00C5FC"
                        stopOpacity="0.21"
                    />
                    <stop
                        offset="0.49"
                        stopColor="#00C5FC"
                        stopOpacity="0.38"
                    />
                    <stop
                        offset="0.65"
                        stopColor="#00C5FC"
                        stopOpacity="0.58"
                    />
                    <stop
                        offset="0.82"
                        stopColor="#00C5FC"
                        stopOpacity="0.83"
                    />
                    <stop offset="0.93" stopColor="#00C5FC" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_223_5711"
                    x1="2.53673"
                    y1="77.8692"
                    x2="15.4967"
                    y2="64.9092"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#00C5FC" stopOpacity="0" />
                    <stop
                        offset="0.06"
                        stopColor="#00C3FB"
                        stopOpacity="0.04"
                    />
                    <stop
                        offset="0.18"
                        stopColor="#00C1FA"
                        stopOpacity="0.16"
                    />
                    <stop
                        offset="0.33"
                        stopColor="#00BCF8"
                        stopOpacity="0.36"
                    />
                    <stop offset="0.5" stopColor="#00B6F5" stopOpacity="0.63" />
                    <stop offset="0.7" stopColor="#00AEF1" stopOpacity="0.96" />
                    <stop offset="0.72" stopColor="#00AEF1" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_223_5711"
                    x1="3.12673"
                    y1="79.9097"
                    x2="89.2167"
                    y2="79.9097"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#00C5FC" />
                    <stop offset="0.07" stopColor="#00BCF6" />
                    <stop offset="0.7" stopColor="#0279C9" />
                    <stop offset="1" stopColor="#045FB8" />
                </linearGradient>
            </defs>
        </svg>
    )
}

export default Cloud
